<template>
  <!-- Input form for the 2FA token -->
  <form v-if="!unsupported" @submit.prevent="submit" @keydown="form.onKeydown($event)">
    <!-- Input Field -->
    <div class="form-group row">
      <div class="col-md-12">
        <input v-model="form.code" :class="{ 'is-invalid': form.errors.has('code') }" :placeholder="$t('enter_code')" class="form-control" type="text" name="code">
        <form-error :form="form" field="code"/>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12 d-flex">
        <!-- Submit Button -->
        <v-button :loading="form.busy">
          {{ $t('send') }}
        </v-button>
      </div>
    </div>
  </form>
</template>

<script>
import FormError from './FormError'
import Form from 'vform'
import { isRecipient, isProfessional, isManager } from '~/plugins/auth'

export default {
  name: 'TwoFactor',
  components: { FormError },
  data: () => ({
    form: new Form({
      code: ''
    }),
    remember: false,
    unsupported: false
  }),
  created () {
    this.unsupported = navigator.userAgent.match(/Trident|MSIE/g)
  },
  methods: {
    async submit () {
      // Submit the form.
      const { data } = await this.form.post('/api/2fa')

      // Redirection.
      if (isRecipient(this.$store.state.auth.user)) { this.$router.push({ name: 'settings.profile', params: { id: this.$store.state.auth.user.id } }) } else {
        if (isProfessional(this.$store.state.auth.user) || isManager(this.$store.state.auth.user)) { this.$router.push({ name: 'manage.recipients' }) } else { this.$router.push({ name: 'manage.users' }) }
      }
    }
  }
}
</script>

<style scoped>
   p{
      font-size: 15px;
   }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/TwoFactor.vue